/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Hero_LeadInputs */

const es_l7_hero_lead = /** @type {(inputs: L7_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde agosto de 2025 puedes alquilar tu barco en Lista séptima hasta tres meses al año. Nosotros nos encargamos de todo el papeleo. Tú solo registras tu barco.`)
};

const gl_l7_hero_lead = /** @type {(inputs: L7_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde agosto de 2025 podes alugar o teu barco na Lista sétima ata tres meses ao ano. Nós encargámonos de todo o papeleo. Ti só rexistras o teu barco.`)
};

const en_l7_hero_lead = /** @type {(inputs: L7_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From August 2025 you can rent out your List 7 boat for up to three months a year. We handle all the paperwork. You just list your boat.`)
};

/**
* | output |
* | --- |
* | "From August 2025 you can rent out your List 7 boat for up to three months a year. We handle all the paperwork. You just list your boat." |
*
* @param {L7_Hero_LeadInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_hero_lead = /** @type {((inputs?: L7_Hero_LeadInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Hero_LeadInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_hero_lead(inputs)
	if (locale === "en") return en_l7_hero_lead(inputs)
	return es_l7_hero_lead(inputs)
});